var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-business-card-add"},[_c('div',{staticClass:"icon",style:({backgroundImage: `url(${require('@/assets/image/base/add/icons_24pt_add_black.svg')})`})}),_vm._v(" "+_vm._s(_vm.$t('AddFlight'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }